import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EmaFirmUserDto, EnterpriseLabels, getEnterpriseLabels, OrganizationDto, OrganizationSearchComponent, SecurityDomain, UserLink } from 'lib';
import { EmaAccountSearchComponent } from '../ema-account-search/ema-account-search.component';
import { EnterpriseLabelsFetchService } from '../../services/enterprise-labels-fetch.service';

@Component({
    selector: 'mmoga-link-ema-accounts',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        OrganizationSearchComponent,
        EmaAccountSearchComponent
    ],
    templateUrl: './link-ema-accounts.component.html',
    styleUrl: './link-ema-accounts.component.scss'
})
export class LinkEmaAccountsComponent implements OnInit {
    private readonly enterpriseLabelsFetchService = inject(EnterpriseLabelsFetchService);

    @Input() currentEnterpriseId!: number;
    @Output() linkEmaAccountsFormUpdated = new EventEmitter<{ value: UserLink[], valid: boolean }>();

    enterpriseLabels: EnterpriseLabels = getEnterpriseLabels(SecurityDomain.MODMED);

    form: FormGroup = new FormGroup({
        rows: new FormArray<FormGroup>([
            new FormGroup({
                selectedOrganization: new FormControl<OrganizationDto | null>(null, Validators.required),
                selectedEmaAccount: new FormControl<EmaFirmUserDto | null>(null, Validators.required)
            })
        ])
    });

    ngOnInit(): void {
        this.enterpriseLabelsFetchService.getEnterpriseLabels().then(
            labels => this.enterpriseLabels = labels
        );
        this.form.valueChanges.subscribe( () => {
            const userLinks = [] as UserLink[];
            this.rows.controls
                .map(control => {
                    userLinks.push({
                        systemId: 'EMA',
                        organizationId: control.get('selectedOrganization')?.value?.id,
                        userId: control.get('selectedEmaAccount')?.value?.internalId,
                        primary: false
                    } as UserLink);
                });
            this.linkEmaAccountsFormUpdated.emit({ value: userLinks, valid: this.form.valid });
        });
    }

    get rows(): FormArray<FormGroup> {
        return this.form.get('rows') as FormArray<FormGroup>;
    }

    addRow(): void {
        this.rows.push(new FormGroup({
            selectedOrganization: new FormControl<OrganizationDto | null>(null, Validators.required),
            selectedEmaAccount: new FormControl<EmaFirmUserDto | null>(null, Validators.required)
        }));
    }

    removeRow(event: Event, index: number): void {
        event.preventDefault();
        this.rows.removeAt(index);
    }

    selectedOrganizationChanged(selectedOrganization: OrganizationDto, index: number): void {
        this.rows.at(index).get('selectedOrganization')?.setValue(selectedOrganization);
        this.rows.at(index).get('selectedOrganization')?.markAsTouched();

    }

    selectedEmaAccountChanged(selectedEmaAccount: EmaFirmUserDto | null, index: number): void {
        this.rows.at(index).get('selectedEmaAccount')?.setValue(selectedEmaAccount);
        this.rows.at(index).get('selectedEmaAccount')?.markAsTouched();

    }

    getSelectedEmaAccountIds(): number[] {
        return this.rows.controls
            .map(control => control.get('selectedEmaAccount')?.value?.id)
            .filter((id): id is number => id !== null && id !== undefined);
    }
}
